import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  timeSheets: [],
  timeSheetRequests: [],
  timeSheet: {},
  timeSheetToday: {},
  timeSheetsExport: [],
  timeSheetSummary: [],
  timeSheetSummaryExport: [],
  timeSheetSubmits: [],
  timeSheetHistory: [],
  timeSheetUnsubmit: [],
  remindHistoryList: [],
  remindEmployeeHistoryList: [],
  employeeTimesheetSummary: {},
  employeeTimesheetDetail: [],
  employeeTotalRequest: {
    totalOTRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalTimesheetRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalSabbaticalRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalRemoteRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    }
  },
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    totalRecordSubmit:0,
    perPage: 0
  }
};

// getters
export const getters = {
  timeSheets: state => state.timeSheets,
  timeSheet: state => state.timeSheet,
  timeSheetSummary: state => state.timeSheetSummary,
  timeSheetRequests: state => state.timeSheetRequests,
  timeSheetSubmits: state => state.timeSheetSubmits,
  timeSheetHistory: state => state.timeSheetHistory,
  timeSheetUnsubmit: state => state.timeSheetUnsubmit,
  pagination: state => state.pagination,
  timeSheetToday: state => state.timeSheetToday,
  timeSheetsExport: state => state.timeSheetsExport,
  timeSheetSummaryExport: state => state.timeSheetSummaryExport,
  remindHistoryList: state => state.remindHistoryList,
  remindEmployeeHistoryList: state => state.remindEmployeeHistoryList,
  employeeTimesheetSummary: state => state.employeeTimesheetSummary,
  employeeTimesheetDetail: state => state.employeeTimesheetDetail,
  employeeTotalRequest: state => state.employeeTotalRequest,
};

// mutations
export const mutations = {
  [types.TIMESHEET.COUNT_SUBMITTED_TIMESHEET](state, countSubmittedEmployee) {
    state.countSubmittedEmployee = countSubmittedEmployee;
  },
  [types.TIMESHEET.FETCH_TIMESHEET](state, timeSheets) {
    state.timeSheets = timeSheets;
    state.pagination.from = timeSheets.from;
    state.pagination.to = timeSheets.to;
    state.pagination.totalPage = timeSheets.last_page;
    state.pagination.path = timeSheets.path;
    state.pagination.currentPage = timeSheets.current_page;
    state.pagination.totalRecord = timeSheets.total;
    state.pagination.totalRecordSubmit = timeSheets.totalEmployees;
    state.pagination.perPage = timeSheets.per_page;
  },
  [types.TIMESHEET.DETAIL_timesheet](state, timeSheet) {
    state.timeSheet = timeSheet;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_REQUEST](state, timeSheetRequests) {
    state.timeSheetRequests = timeSheetRequests;
    state.pagination.from = timeSheetRequests.from;
    state.pagination.to = timeSheetRequests.to;
    state.pagination.totalPage = timeSheetRequests.last_page;
    state.pagination.path = timeSheetRequests.path;
    state.pagination.currentPage = timeSheetRequests.current_page;
    state.pagination.totalRecord = timeSheetRequests.total;
    state.pagination.totalRecordSubmit = timeSheetRequests.totalEmployees;
    state.pagination.perPage = timeSheetRequests.per_page;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_TODAY](state, timeSheet) {
    state.timeSheetToday = timeSheet;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_EXPORT](state, timeSheetsExport) {
    state.timeSheetsExport = timeSheetsExport;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_EXPORT_LIST_SUBMIT](state, timeSheetsExport) {
    state.timeSheetsExport = timeSheetsExport;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_SUBMIT_HISTORY](state, timeSheetHistory) {
    state.timeSheetHistory = timeSheetHistory;
  },

  [types.TIMESHEET.FETCH_TIMESHEET_SUBMIT_UNSUBMIT](state, timeSheetUnsubmit) {
    state.timeSheetUnsubmit = timeSheetUnsubmit;
  },

  [types.TIMESHEET.FETCH_TIMESHEET_SUMMARY](state, timeSheetSummary) {
    state.timeSheetSummary = timeSheetSummary;
    state.pagination.from = timeSheetSummary.from;
    state.pagination.to = timeSheetSummary.to;
    state.pagination.totalPage = timeSheetSummary.last_page;
    state.pagination.path = timeSheetSummary.path;
    state.pagination.currentPage = timeSheetSummary.current_page;
    state.pagination.totalRecord = timeSheetSummary.total;
    state.pagination.totalRecordSubmit = timeSheetSummary.totalEmployees;
    state.pagination.perPage = timeSheetSummary.per_page;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_SUMMARY_EXPORT](
    state,
    timeSheetSummaryExport
  ) {
    state.timeSheetSummaryExport = timeSheetSummaryExport;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_SUBMIT](state, timeSheets) {
    state.timeSheetSubmits = timeSheets.data;
    state.pagination.from = timeSheets.from;
    state.pagination.to = timeSheets.to;
    state.pagination.totalPage = timeSheets.last_page;
    state.pagination.path = timeSheets.path;
    state.pagination.currentPage = timeSheets.current_page;
    state.pagination.totalRecord = timeSheets.total;
    state.pagination.totalRecordSubmit = timeSheets.totalEmployees;
    state.pagination.perPage = timeSheets.per_page;
  },
  [types.TIMESHEET.FETCH_REMIND_HISTORY_LIST](state, remindHistoryList) {
    state.remindHistoryList = remindHistoryList.data;
    state.pagination.from = remindHistoryList.from;
    state.pagination.to = remindHistoryList.to;
    state.pagination.totalPage = remindHistoryList.last_page;
    state.pagination.path = remindHistoryList.path;
    state.pagination.currentPage = remindHistoryList.current_page;
    state.pagination.totalRecord = remindHistoryList.total;
    state.pagination.totalRecordSubmit = remindHistoryList.totalEmployees;
    state.pagination.perPage = remindHistoryList.per_page;
  },
  [types.TIMESHEET.FETCH_EMPLOYEE_REMIND_HISTORY_LIST](state, remindEmployeeHistoryList) {
    state.remindEmployeeHistoryList = remindEmployeeHistoryList;
  },
  [types.TIMESHEET.FETCH_EMPLOYEE_TOTAL_REQUEST](state, data) {
    state.employeeTotalRequest = { ...state.employeeTotalRequest,...data};
    
  },
  [types.TIMESHEET.FETCH_EMPLOYEE_TIMESHEET_DETAIL](state, data) {
    state.employeeTimesheetDetail = data;
  },
  [types.TIMESHEET.FETCH_EMPLOYEE_TIMESHEET_SUMMARY](state, data) {
    state.employeeTimesheetSummary = data;
  }
};

// actions
export const actions = {
  async fetchTimeSheet({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET, response.data.timeSheets);
  },
  async fetchUserTimeSheet({
    commit
  }, payload) {
    const response = await axios.get(api.USER_TIME_SHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET, response.data.timeSheets);
  },
  async checkIn() {
    await axios.post(api.USER_CHECK_IN);
  },
  async checkOut() {
    await axios.post(api.USER_CHECK_OUT);
  },
  async fetchTimeSheetRequest({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET_REQUEST, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        status: payload.status
      }
    });
    commit(
      types.TIMESHEET.FETCH_TIMESHEET_REQUEST,
      response.data.timeSheetRequests
    );
  },
  async fetchTimeSheetToday({
    commit
  }) {
    const response = await axios.get(api.TIME_SHEET_TODAY);
    commit(types.TIMESHEET.FETCH_TIMESHEET_TODAY, response.data.timeSheet);
  },
  // eslint-disable-next-line
  async updateTimeSheet({
    commit
  }, data) {
    let url = `${api.TIME_SHEET}/${data.id}`;
    await axios.put(url, data).then(res => res);
  },
  // eslint-disable-next-line
  async importTimesheet({
    commit
  }, payload) {
    await axios.post(api.IMPORT_TIMESHEET, {
      data: payload.data
    });
  },
  async fetchTimeSheetsExport({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        export: payload.export
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_EXPORT, response.data.timeSheets);
  },
  async fetchTimeSheetSummary({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET_SUMMARY, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info
      }
    });
    commit(
      types.TIMESHEET.FETCH_TIMESHEET_SUMMARY,
      response.data.timeSheetSummary
    );
  },
  async fetchTimeSheetSummaryExport({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET_SUMMARY, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        export: payload.export
      }
    });
    commit(
      types.TIMESHEET.FETCH_TIMESHEET_SUMMARY_EXPORT,
      response.data.timeSheetSummary
    );
  },

  async submitCompany(payload) {
    await axios.post(api.SUBMIT_COMPANY_TIMESHEET, payload);
  },

  async submitEmployee(payload) {
    await axios.post(api.SUBMIT_EMPLOYEE_TIMESHEET, payload);
  },

  async countSubmitEmployee({
    commit
  }, payload) {
    const response = await axios.get(api.COUNT_EMPLOYEE_SUBMIT, {
      params: {
        month: payload.month
      }
    });
    commit(types.TIMESHEET.COUNT_SUBMITTED_TIMESHEET, response.data);
  },

  async fetchTimeSheetSubmit({
    commit
  }, payload) {
    const response = await axios.get(api.GET_TIMESHEET_SUBMITS, {
      params: {
        ...payload,
        page: payload.currentPage
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_SUBMIT, response.data);
  },
  async TimeSheetsHistory({
    commit
  }, payload) {
    const response = await axios.get(api.GET_TIMESHEET_HISTORY, {
      params: {
        month: payload.month,
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_SUBMIT_HISTORY, response.data);
  },

  async fetchTimeSheetsExportListSubmit({
    commit
  }, payload) {
    const response = await axios.get(api.GET_TIMESHEET_SUBMITS, {
      params: {
        ...payload,
        page: payload.currentPage
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_EXPORT, response.data);
  },

  async TimeSheetsUnsubmit({
    commit
  }, payload) {
    const response = await axios.get(api.GET_TIMESHEET_UNSUBMIT, {
      params: {
        ...payload,
        page: payload.currentPage
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_SUBMIT_UNSUBMIT, response.data);
  },

  async UnsubmitRemindTimeSheet({
    _
  }, payload) {
    await axios.post(api.UPDATE_TIMESHEET_UNSUBMIT, {
        month: payload.month,
    });
  },

  async resendUnsubmitRemindTimeSheet({
    _
  }, payload) {
    await axios.post(api.RESEND_REMIND_UNSUBMIT, {
      id: payload.id,
      month: payload.month
    });
  },

  async remindHistoryList({
    commit
  }, payload) {
    const response = await axios.get(api.GET_REMIND_HISTORY_LIST, {
      params: {
        page: payload.currentPage,
        status: payload.status,
        month: payload.month,
      }
    });
    commit(types.TIMESHEET.FETCH_REMIND_HISTORY_LIST, response.data);
  },

  async employeeRemindHistoryList({
    commit
  }, payload) {
    const response = await axios.get(api.GET_EMPLOYEE_REMIND_HISTORY_LIST, {
      params: {
        id: payload.id
      }
    });
    commit(types.TIMESHEET.FETCH_EMPLOYEE_REMIND_HISTORY_LIST, response.data);
  },
  async fetchEmployeeTimesheetDetail({
    commit
  }, payload) {
    const response = await axios.get(api.GET_EMPLOYEE_TIMESHEET_DETAIL, {
      params: {
        per_page: "31",
        page: 1,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: 0,
        foot_code: 0,
        division_code: 0,
        employee_info: payload.employee_info,
      }
    });
    commit(
      types.TIMESHEET.FETCH_EMPLOYEE_TIMESHEET_DETAIL,
      response.data.timeSheets.data
    );
  },
  async fetchEmployeeTotalRequest({
    commit
  }, payload) {
    const response = await axios.get(api.GET_EMPLOYEE_TOTAL_REQUEST, {
      params: {
        month: payload.month,
        employee_info: payload.employee_info,
      }
    });
    commit(
      types.TIMESHEET.FETCH_EMPLOYEE_TOTAL_REQUEST,
      response.data
    );
  },
  async fetchEmployeeTimesheetSummary({
    commit
  }, payload) {
    const response = await axios.get(api.GET_EMPLOYEE_TIMESHEET_SUMMARY, {
      params: {
        per_page: "10",
        page: 1,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: 0,
        foot_code: 0,
        division_code: 0,
        employee_info: payload.employee_info,
      }
    });
    commit(
      types.TIMESHEET.FETCH_EMPLOYEE_TIMESHEET_SUMMARY,
      response.data.timeSheetSummary.data[0]
    );
  },
};
